/* eslint-disable no-underscore-dangle */
export default class FileUpload {
  constructor(props) {
    this.root = props.element;
    this.input = props.element.querySelector('input[type="file"]');
    this.fakeInput = props.element.querySelector('.js-filename');
    this.__changeListener = this.__changeListener.bind(this);
  }

  __changeListener(event) {
    const { target } = event;
    const fileName = target.files[0] ? target.files[0].name : undefined;
    if (fileName) {
      this.__handleHasFile(fileName);
    }
  }

  __handleHasFile(fileName) {
    this.fakeInput.innerText = fileName;
    this.fakeInput.setAttribute('title', fileName);
    this.root.classList.remove('bfv-file-upload--error');
  }

  init() {
    this.input.addEventListener('change', this.__changeListener);
  }
}
